// @flow
import React from 'react'
import { SimpleGrid } from '@driftt/dds'
import { Div, Header, H5, H4, A, P, Span, Toggle } from '@driftt/tide-core'
import { Button, Flex } from '@driftt/dds'
import { access } from '@driftt/traffic-control'

import './style.css'

const SyncStep = ({ openCreateOrEditAccountSidebar}) => (
  <Div className="accounts-onboarding-step sync-step">
    <Div className="accounts-onboarding--content">
      <H5>Add your VIP Accounts to Drift</H5>
      <P>Give your leads a fast lane to your sales team!</P>
    </Div>

    <Flex direction='column' css={{margin: '$2 0'}}>
      <Button onClick={() => window.open("/settings2/integrations/detail/salesforce")}>Sync from Salesforce</Button>
      <Button variant="secondary" onClick={() => openCreateOrEditAccountSidebar()}>Add an account</Button>
    </Flex>
  </Div>
)

const NotificationStep = ({ toggleAccountFollow, hasFollowAccounts }) => (
  <Div className={"accounts-onboarding-step notifications-step"}>
    <Div className="accounts-onboarding--content">
      <H5>Get notified when your accounts are online</H5>
      <P><A type="small" href="/settings/notifications">Turn on notifications</A> and follow your targeted accounts, Drift will notify you when they're on your site!</P>
    </Div>
    {!access.hasGates('saved_filters_push_notifications') &&
      <Div className="accounts-onboarding-step--actions">
        <Span>Follow your target accounts</Span>
        <Toggle size="small" defaultChecked={hasFollowAccounts} className="onboarding-accounts-follow-toggle" onChange={toggleAccountFollow} />
      </Div>
    }
  </Div>
)

const PlaybookStep = () => (
  <Div className="accounts-onboarding-step playbook-step">
    <Div className="accounts-onboarding--content">
      <H5>Roll out the red carpet with an ABM playbook</H5>
      <P>Create a new playbook to automatically greet your targeted accounts!</P>
    </Div>
    <Flex css={{margin: '$2 0'}}>
      <Button onClick={() => window.open("/playbooks")}>Create an ABM playbook</Button>
    </Flex>
  </Div>
)

const AccountsOnboarding = ({ onHide, openCreateOrEditAccountSidebar, toggleAccountFollow, hasFollowAccounts, onHideForever }) => (
  <Div className="accounts-onboarding">
    <Header>
      <H4>Get started with Drift ABM</H4>
      <Div className="accounts-onboarding-dismiss">
        <Span>Dismiss</Span>
        <Div>
          <Span onClick={onHide}>For now?</Span>
          <Span onClick={onHideForever}>Forever?</Span>
        </Div>
      </Div>
    </Header>

    <SimpleGrid columns={3} className="accounts-onboarding-steps">
      <SyncStep openCreateOrEditAccountSidebar={openCreateOrEditAccountSidebar} />
      <NotificationStep hasFollowAccounts={hasFollowAccounts} toggleAccountFollow={toggleAccountFollow} />
      <PlaybookStep />
    </SimpleGrid>
  </Div>
)

export default ({show, ...rest}) => show ? <AccountsOnboarding {...rest} /> : null
